import '@/bootstrap'
import {i18nVue} from 'laravel-vue-i18n'
import {configureEcho} from '@laravel/echo-vue'
import {createInertiaApp} from '@inertiajs/vue3'
import {createApp, type DefineComponent, h} from 'vue'
import '@dzangolab/vue-country-flag-icon/dist/CountryFlag.css'

configureEcho({
	broadcaster: 'reverb',
})

const time: number = Date.now()

createInertiaApp({
	resolve: (name: string): DefineComponent => {
		const pages: Record<string, DefineComponent> = import.meta.glob('./Pages/**/*.vue', {
			eager: true,
		})
		return pages[`./Pages/${name}.vue`]
	},
	setup({el, App, props, plugin}): void{
		createApp({render: () => h(App, props)})
		.use(plugin)
		.use(i18nVue, {
			resolve: (lang:string) => {
				const languages:Record<string, any> = import.meta.glob('/resources/lang/*.json', {
					eager: true,
				})
				return languages[`/resources/lang/${lang}.json`].default
			},
		})
		.mount(el)
	},
}).then((): void => {
	console.log(`Loaded app in ${(Date.now() - time) / 1000} seconds!`)
})